import Vue from 'vue'
import App from './App.vue'
import { router } from "./router.js";
import VModal from 'vue-js-modal'
import VueCarousel from 'vue-carousel';
import svgJs from "./vueSvg"
import store from './store'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapMarkerAlt,faCross,faCalendar,faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BootstrapVue from 'bootstrap-vue'

import VueSelect from 'vue-cool-select'

import browserDetect from "vue-browser-detect-plugin";

Vue.use(browserDetect);

library.add(faMapMarkerAlt,faCross,faCalendar,faDownload)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import VeeValidate from 'vee-validate';

import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import 'vue-search-select/dist/VueSearchSelect.css'

Vue.use(Autocomplete)
Vue.use(VeeValidate);

Vue.use(BootstrapVue)
Vue.use(VModal)
Vue.use(VueCarousel);
Vue.use(svgJs);

Vue.use(VueSelect, {
  theme: 'bootstrap' // or 'material-design'
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
